import React, { useState } from "react";
import "./style.scss";
import sketchTop from "../../../assets/images/footer-top-texturev2.png";
import sketchBottom from "../../../assets/images/footer-bottom-texturev2.png";
import portfolio1 from '../../../assets/images/portfolio/new1.webp'
import portfolio2 from '../../../assets/images/portfolio/new2.webp'
import portfolio3 from '../../../assets/images/portfolio/new3.webp'
import portfolio4 from '../../../assets/images/portfolio/new4.webp'
import portfolio5 from '../../../assets/images/portfolio/new5.webp'
import portfolio6 from '../../../assets/images/portfolio/new6.webp'
import portfolio7 from '../../../assets/images/portfolio/new7.webp'
import portfolio8 from '../../../assets/images/portfolio/new8.webp'
import portfolio9 from '../../../assets/images/portfolio/new9.webp'
import portfolio10 from '../../../assets/images/portfolio/new10.webp'
import portfolio11 from '../../../assets/images/portfolio/new11.webp'
import portfolio12 from '../../../assets/images/portfolio/new12.webp'
import portfolio13 from '../../../assets/images/portfolio/new13.webp'
import portfolio14 from '../../../assets/images/portfolio/new14.webp'
import portfolio15 from '../../../assets/images/portfolio/new15.webp'
import portfolio16 from '../../../assets/images/portfolio/new16.webp'
import portfolio17 from '../../../assets/images/portfolio/new17.jpeg'
import portfolio18 from '../../../assets/images/portfolio/new18.jpeg'
import portfolio19 from '../../../assets/images/portfolio/new19.jpeg'
import portfolio20 from '../../../assets/images/portfolio/new20.jpeg'
import portfolio21 from '../../../assets/images/portfolio/new21.jpeg'
import portfolio22 from '../../../assets/images/portfolio/new22.jpeg'
import portfolio23 from '../../../assets/images/portfolio/new23.jpeg'
import portfolio25 from '../../../assets/images/portfolio/new25.jpeg'
import portfolio26 from '../../../assets/images/portfolio/new26.jpeg'
import portfolio27 from '../../../assets/images/portfolio/new27.jpeg'
import portfolio28 from '../../../assets/images/portfolio/new28.jpeg'
import portfolio29 from '../../../assets/images/portfolio/new29.webp'
import portfolio30 from '../../../assets/images/portfolio/new30.webp'
import portfolio31 from '../../../assets/images/portfolio/new31.webp'
import portfolio32 from '../../../assets/images/portfolio/new32.webp'
import portfolio33 from '../../../assets/images/portfolio/new33.webp'
import portfolio34 from '../../../assets/images/portfolio/new34.webp'
import portfolio35 from '../../../assets/images/portfolio/new35.webp'
import portfolio36 from '../../../assets/images/portfolio/new36.webp'



const Index = ({ setFullImage }) => {


    const portfolioData = [
        {
            imageUrl: portfolio1,
        },
        {
            imageUrl: portfolio2,
        },
        {
            imageUrl: portfolio3,
        },
        {
            imageUrl: portfolio4,
        },
        {
            imageUrl: portfolio5,
        },
        {
            imageUrl: portfolio6,
        },
        {
            imageUrl: portfolio7,
        },
        {
            imageUrl: portfolio8,
        },
        {
            imageUrl: portfolio9,
        },
        {
            imageUrl: portfolio10,
        },
        {
            imageUrl: portfolio11,
        },
        {
            imageUrl: portfolio12,
        },
        {
            imageUrl: portfolio13,
        },
        {
            imageUrl: portfolio14,
        },
        {
            imageUrl: portfolio15,
        },
        {
            imageUrl: portfolio16,
        },
        {
            imageUrl: portfolio17,
        },
        {
            imageUrl: portfolio18,
        },
        {
            imageUrl: portfolio19,
        },
        {
            imageUrl: portfolio20,
        },
        {
            imageUrl: portfolio21,
        },
        {
            imageUrl: portfolio22,
        },
        {
            imageUrl: portfolio23,
        },
        {
            imageUrl: portfolio25,
        },
        {
            imageUrl: portfolio26,
        },
        {
            imageUrl: portfolio27,
        },
        {
            imageUrl: portfolio28,
        },
        {
            imageUrl: portfolio29,
        },
        {
            imageUrl: portfolio30,
        },
        {
            imageUrl: portfolio31,
        },
        {
            imageUrl: portfolio32,
        },
        {
            imageUrl: portfolio33,
        },
        {
            imageUrl: portfolio34,
        },
        {
            imageUrl: portfolio35,
        },
        {
            imageUrl: portfolio36,
        },
    ]

    const PortfolioCard = ({ v }) => {
        const [isHovered, setIsHovered] = useState(false);
        // let scrollingInterval;

        // const scrollingDivRef = useRef(null);

        // const startScrolling = () => {
        //     scrollingInterval = setInterval(() => {
        //         scrollingDivRef.current.scrollTop += 1;
        //     }, 20);
        // };

        // const stopScrolling = () => {
        //     clearInterval(scrollingInterval);
        // };

        return <div
            onMouseEnter={() => {
                setIsHovered(true);
                // startScrolling();
            }}
            onMouseLeave={() => {
                setIsHovered(false);
                // stopScrolling();
            }}
            // ref={scrollingDivRef}
            className={`mt-3 col-md-4`}>
            <div className={`portfolio__card__main w-100 position-relative`}>
                {isHovered ? <div onClick={() => setFullImage(v?.imageUrl)} className="hoverd__div">

                </div> : null}
                <img className="w-100" src={v.imageUrl} alt="portfolio" />
            </div>
        </div>
    }

    // chicken lion cat
    return (
        <>
            <div className="portfolio__card__section__main">
                <img className="sketh__images" src={sketchBottom} alt="sketch top" />
                <div className="about__sub__section">
                    <div className="container">
                        <div className="row portfolio__card__section">
                            {portfolioData?.map((v, i) => {
                                return <PortfolioCard v={v} key={i} />
                            })}
                        </div>
                    </div>
                    <img
                        className="sketh__images bottom__sketch"
                        src={sketchTop}
                        alt="sketch top"
                    />
                </div>
            </div>
        </>
    );
};

export default Index;
